import './App.css';
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepButton from "@mui/material/StepButton";
import React, {useEffect, useRef, useState} from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import PaymentForm from "./OrderDetailComponent";
import Review from "./PersonComponent";
import {createTheme} from "@mui/material";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Copyright from "./Copyright";
import Grid from "@mui/material/Grid";
import LoadingButton from '@mui/lab/LoadingButton';
import {evropa, hitMladost, lulin, mladost} from "./DepartamentsInfo";
import ToolbarComponent from "./ToolbarComponent";
import moment from "moment";
import MessageDialog from "./MessageDialog";
import {useSearchParams} from "react-router-dom";
import {Alert} from "@mui/lab";

export const EVROPA_PROMO = 'evropaPromo';

/*
  Промо кодовете се проверяват от бекенда — GET /api/promo-code/check?code=<код>

  Отговор:
  {
    "exists": true,
    "is_used": false,
    "code": "wVKi9yS0",
    "requires_paper": false,
    "client_id": 82887,
    "order_id": null,
    "used_at": null
  }

  Кодът важи само когато exists === true и is_used === false.
  Отговорът не носи данни за самата кампания, затова отстъпката и
  ограниченията (услуга / обект) стоят в константите по-долу.

  Размерът на отстъпката зависи от партньорския канал (?origin=) и от
  requires_paper. Същите правила стоят и в бекенда - виж
  ReservationController::saveWebReservation, двете трябва да съвпадат.
*/
const PROMO_DISCOUNT_LABEL = '20 €';
const PROMO_DISCOUNT_LABEL_MVR = '33%';
const PROMO_DISCOUNT_LABEL_PRAKTIKER = '20%';

// Партньорските канали, които бекендът разпознава (RESERVATION_ORIGINS)
const PROMO_ORIGINS = ['mvr', 'praktiker', 'any-company'];

const getPromoDiscountLabel = (origin, requiresPaper) => {
  if (origin === 'mvr' || requiresPaper) {
    return PROMO_DISCOUNT_LABEL_MVR;
  }

  if (origin === 'praktiker') {
    return PROMO_DISCOUNT_LABEL_PRAKTIKER;
  }

  return PROMO_DISCOUNT_LABEL;
};

// ГТП в обект Младост 3 (паркинг на HIT Max) — единствената услуга и обект за промо кода
const PROMO_SERVICE_TYPE = 7;
const PROMO_SERVICE_IDS = [6];

const isPromoCodeValid = (promoResponse) => !!(
    promoResponse && promoResponse.exists && !promoResponse.is_used && !promoResponse.is_reserved
);

function MainForm(props) {
  const [searchParams, setSearchParams] = useSearchParams();


  const [externalPromoCode, setExternalPromoCode] = React.useState(searchParams.get('promo_code'));

  // Партньорският канал от ?origin=, само ако е един от разпознатите
  const externalOrigin = PROMO_ORIGINS.includes(searchParams.get('origin')) ? searchParams.get('origin') : null;

  // Афилиейт линк от ?ref= - бекендът проверява кода, тук само се предава нататък
  const externalAffiliateCode = searchParams.get('ref');

  // Текстът на банера от /api/affiliate-link/check - само за валиден (съществуващ и активен) линк
  const [affiliateText, setAffiliateText] = React.useState(null);

  // Списъкът с отстъпки става дълъг и изтласква формата надолу, затова от 4 точки
  // нагоре точките се разливат на две колони (на телефон остават на една).
  // Обикновените редове (напр. изречение преди списъка) остават на цялата ширина.
  const affiliateTextBlocks = (affiliateText || '')
      .split('\n')
      .filter(row => row.trim() !== '')
      .reduce((blocks, row) => {
        const isBullet = /^\s*([-•*–—]|\d+[.)])\s*/.test(row);
        const last = blocks[blocks.length - 1];

        if (last && last.isBullet === isBullet) {
          last.rows.push(row);
        } else {
          blocks.push({isBullet, rows: [row]});
        }

        return blocks;
      }, []);

  // Отговорът от /api/promo-code/check (виж контракта по-горе)
  const [promoResponse, setPromoResponse] = React.useState(null);
  const [promoLoading, setPromoLoading] = React.useState(false);

  const isPromoApplied = isPromoCodeValid(promoResponse);
  const promoCodeUsed = !!(promoResponse && promoResponse.exists && promoResponse.is_used);
  const promoCodeInvalid = !!(promoResponse && !promoResponse.exists);
  // Вече има запазен час с този ваучер, който още не е приключен
  const promoCodeReserved = !!(promoResponse && promoResponse.exists && !promoResponse.is_used && promoResponse.is_reserved);

  // Ограниченията, които валидният код налага на формата
  const promo = isPromoApplied ? {
    code: promoResponse.code || externalPromoCode,
    discountLabel: getPromoDiscountLabel(externalOrigin, !!promoResponse.requires_paper),
    serviceType: PROMO_SERVICE_TYPE,
    serviceIds: PROMO_SERVICE_IDS,
  } : null;

  const [externalProductName, setExternalProductName] = React.useState(searchParams.get('product_name'));
  const [externalProductQuantity, setExternalProductQuantity] = React.useState(searchParams.get('product_quantity'));
  const [externalProductPrice, setExternalProductPrice] = React.useState(searchParams.get('price'));
  const [externalProductImage, setExternalProductImage] = React.useState(searchParams.get('productImg'));


  /*
    1.1.
  */
  const [service, setService] = React.useState('');

  /*
    1.2.
  */
  const [serviceType, setServiceType] = React.useState('');
  const [date, setDate] = useState(null);
  const [formattedDate, setFormattedDate] = useState(null);
  const [hourSelected, setHourSelected] = React.useState('');

  /*
    2.
   */
  const [phone, setPhone] = useState(null);
  const [plate, setPlate] = useState(null);

  const [name, setName] = useState(null);
  const [clientId, setClientId] = useState(0);
  const [email, setEmail] = useState(null);

  const [brand, setBrand] = useState(null);
  const [brandName, setBrandName] = useState(null);

  const [isHotelVisible, setHotelVisible] = useState(false);
  const [hotelPersonalChoice, setHotelPersonalChoice] = useState(null);
  const [hotelToCar, hasHotelToCar] = useState(false);
  const [hotelShelf, setHotelShelf] = useState(null);

  const [hotelOtherServiceOpen, setHotelOtherServiceOpen] = useState(false);

  const [message, setMessage] = React.useState(null);
  const [reservationFinished, setReservationFinished] = React.useState(null);

  const clearAll = () => {
    setService('')
    setServiceType('')
    setDate(null)
    setFormattedDate(null)
    setHourSelected('')
    setPhone(null)
    setPlate(null)
    setName(null)
    setClientId(null)
    setEmail(null)
    setBrand(null)
    setBrandName(null)
    setNotificationLink(null)

    setHotelPersonalChoice(null)

    setHotelVisible(false)
    setHotelOtherServiceOpen(false)

    setExternalProductName(null)
    setExternalProductQuantity(null)

    setExternalPromoCode(null)
    setPromoResponse(null)
    setPromoLoading(false)
    setBlocked(null)
  }

  /*
  Thank you page
   */
  const [notificationLink, setNotificationLink] = useState(null);

  const [isBlocked, setBlocked] = useState(false);

  const steps = ['Услуга', 'Сервиз', 'Клиент'];
  const stepDirectionRef = useRef('forward');

  const navigateToStep = (step) => {
    stepDirectionRef.current = step > activeStep ? 'forward' : 'back';
    if (step === 0) setHotelPersonalChoice(null);
    setActiveStep(step);
  };




  function checkHourBusy() {
    let serviceId=service
    //console.log('checking for ', hourSelected)
    let hour = hourSelected;

    if (!reservationFinished && serviceId && serviceType && date && hour) {
      const zeroPad = (num, places) => String(num).padStart(places, '0')

      const dateFormatted = date.year().toString() + "-" + zeroPad((date.month() + 1).toString(), 2) + "-" + zeroPad(date.date().toString(), 2)

      fetch(`${process.env.REACT_APP_URL}/api/schedule?` + new URLSearchParams({
        id: serviceType,
        depid: serviceType,
        data: dateFormatted,
        serviceid: serviceId
      }), {
        method: "GET",
        mode: 'cors',
        headers: {
          "Content-Type": "application/json",
        }
      })
          .then(response => response.json())
          .then(
              (result) => {
                if (result && result.data) {
                  if (props.editMode && props.hourSelectedInitial) {
                    result.data.push({
                      fhour: props.hourSelectedInitial,
                      limit: 1,
                      used: '0',
                      isonline: '0',
                      tmp: '30-Jun-2022 2:38'
                    })
                  }

                  if (props.editMode) {
                    result.data.sort((a, b) => parseFloat(a.fhour) - parseFloat(b.fhour));
                  }

                  let hours = (result.data) ?? [];
                  if (hours.find((h) => (h.fhour === hour) && (Number(h.used) === Number(h.limit))) ||
                      !hours.find((h) => (h.fhour === hour))) {
                    setMessage('За съжаление някой току що зае часът, който искахте да запазите!')
                    setHourSelected('')
                  }
                }
              },
              (error) => {

              }
          );
    }
  }

  const TEN_SEC_MS = 10000;

  useEffect(() => {
    const interval = setInterval(() => {
      if (!reservationFinished) {
        checkHourBusy();
      }
    }, TEN_SEC_MS);

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, [reservationFinished, hourSelected])


  useEffect(() => {
    if (!externalPromoCode) {
      setPromoResponse(null)
      return;
    }

    if (externalPromoCode === EVROPA_PROMO) {
      setService(5)
      return;
    }

    setPromoLoading(true)
    fetch(`${process.env.REACT_APP_URL}/api/promo-code/check?` + new URLSearchParams({
      code: externalPromoCode
    }), {
      method: "GET",
      mode: 'cors',
      headers: {
        "Content-Type": "application/json",
      }
    })
        .then(response => response.json())
        .then(
            (result) => {
              setPromoResponse(result || null)
              if (isPromoCodeValid(result)) {
                setServiceType(PROMO_SERVICE_TYPE)
                if (PROMO_SERVICE_IDS.length === 1) {
                  setService(PROMO_SERVICE_IDS[0])
                }
              }
              setPromoLoading(false)
            },
            (error) => {
              setPromoResponse(null)
              setPromoLoading(false)
            }
        );
  }, [externalPromoCode])


  useEffect(() => {
    if (!externalAffiliateCode) {
      setAffiliateText(null)
      return;
    }

    fetch(`${process.env.REACT_APP_URL}/api/affiliate-link/check?` + new URLSearchParams({
      code: externalAffiliateCode
    }), {
      method: "GET",
      mode: 'cors',
      headers: {
        "Content-Type": "application/json",
      }
    })
        .then(response => response.json())
        .then(
            (result) => {
              setAffiliateText(result && result.valid && result.reservation_text ? result.reservation_text : null)
            },
            (error) => {
              setAffiliateText(null)
            }
        );
  }, [externalAffiliateCode])


  function getStepContent(step) {
    switch (step) {
      case 0:
      case 1:
        return <PaymentForm
            isHotel={isHotelVisible}
            setHotel={setHotelVisible}
            hotelPersonalChoice={hotelPersonalChoice}
            setHotelPersonalChoice={setHotelPersonalChoice}
            hotelOtherServiceOpen={hotelOtherServiceOpen}
            setHotelOtherServiceOpen={setHotelOtherServiceOpen}

            service={service}
            setService={setService}
            serviceType={serviceType}
            setServiceType={setServiceType}
            date={date}
            setDate={setDate}
            setFormattedDate={setFormattedDate}
            hourSelected={hourSelected}
            setHourSelected={setHourSelected}
            handleNext={handleNext}
            activeStep={activeStep}

            externalPromoCode={externalPromoCode}
            promo={promo}
            promoLoading={promoLoading}
            externalProductName={externalProductName}
            externalProductQuantity={externalProductQuantity}
            externalProductPrice={externalProductPrice}
            externalProductImage={externalProductImage}

            setExternalProductName={setExternalProductName}
            setExternalProductQuantity={setExternalProductQuantity}
            setExternalProductPrice={setExternalProductPrice}
            setExternalProductImage={setExternalProductImage}
        />;
      case 2:
        return <Review
            service={service}
            serviceType={serviceType}
            date={date}
            hourSelected={hourSelected}
            setActiveStep={navigateToStep}
            setHotelOtherServiceOpen={setHotelOtherServiceOpen}

            phone={phone}
            setPhone={setPhone}
            plate={plate}
            setPlate={setPlate}
            name={name}
            setName={setName}
            email={email}
            setEmail={setEmail}
            brand={brand}
            setBrand={setBrand}
            brandName={brandName}
            setBrandName={setBrandName}
            clientId={clientId}
            setClientId={setClientId}
            isHotel={isHotelVisible}
            setHotel={setHotelVisible}

            hotelPersonalChoice={hotelPersonalChoice}
            setHotelPersonalChoice={setHotelPersonalChoice}

            hasHotelToCar={hasHotelToCar}
            setHotelShelf={setHotelShelf}
        />;
      default:
        throw new Error('Unknown step');
    }
  }

  const theme = createTheme({
    palette: {
      primary: {main: '#30cfc4'},
    },
  });

  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    stepDirectionRef.current = 'forward';
    setActiveStep(activeStep + 1);
    //window.history.pushState(null, null, window.location.pathname);

    /*if (activeStep === 1) {
      setServiceType("")
      setDate(null)
      setHourSelected("")
    }*/

    if (activeStep === steps.length - 1) {


      //send reservation

      setReservationFinished(true)
      fetch(`${process.env.REACT_APP_URL}/api/reservation`, {
        method: "POST",
        mode: 'cors',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...hotelPersonalChoice === "1" ? {force_add_hotel: "1"} : {force_add_hotel: "0"},
          serviceID: service,
          depid: serviceType,
          data: formattedDate,
          hour: hourSelected,
          reg_plate: plate.licence_plate,
          modelid: plate.make_id || brand,
          modelname: plate.make || brandName,
          cliid: clientId,
          phone: phone ? phone.replace(/ /g,'') : null,
          email: email,
          fullname: name,
          serviceid: service,
          ishotel: hotelToCar ? 1 : null,
          shelf: hotelShelf,
          ...(externalProductName && externalProductQuantity) ? {description: `${externalProductName} - ${externalProductQuantity} бр, цена за бр: €${externalProductPrice}, общо: €${Number(externalProductQuantity) * Number(externalProductPrice)}`} : ((externalPromoCode === EVROPA_PROMO) ? {description: `Преференциални условия за Европа!!!`} : {}),
          ...promo ? {promo_code: promo.code} : {},
          ...externalOrigin ? {origin: externalOrigin} : {},
          ...externalAffiliateCode ? {affiliate_code: externalAffiliateCode} : {}
        })
      })
          .then(response => response.json())
          .then(
              (result) => {
                if (result && result.link) {
                  setNotificationLink(result.link)
                } else if (result && result.err) {
                  setBlocked(true)
                  alert('Възникна системна грешка!')
                }
              },
              (error) => {

              }
          );
    }
  };

  const handleBack = () => {
    stepDirectionRef.current = 'back';
    if (activeStep === 1) setHotelPersonalChoice(null);
    setActiveStep(activeStep - 1);
  };

  const getServiceType = (serviceType, service) => {
    const servicesToCheck = service === 1 ? lulin : (service === 5 ? evropa : (service === 6 ? hitMladost : mladost));


    for (const serviceChecked of servicesToCheck) {
      if (serviceChecked.id === serviceType) {
        return serviceChecked.name;
      }
    }
    return "";
  }

  return (
      <React.StrictMode>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AppBar
              position="absolute"
              color="default"
              elevation={0}
              style={{borderBottom: 'none', marginTop: 15}}
              sx={{
                position: 'relative',
                borderBottom: (t) => `1px solid ${t.palette.divider}`,
              }}
          >
            <ToolbarComponent
                clearAll={clearAll} setActiveStep={setActiveStep}/>
          </AppBar>
          <Container component="main" maxWidth="sm" sx={{ mb: 4, pl: { xs: 0.5, sm: 2 } }}>
            <Paper style={{backgroundColor: '#30cfc4'}} elevation={6} sx={{ my: { xs: 2, md: 3 }, p: { xs: 1.1, md: 1 } }}>
              <Typography component="h1" variant="h5" align="center" style={{color: 'white'}}>
                { activeStep === steps.length ?
                    (isBlocked ? 'Системна грешка' : 'Успешна резервация') : 'Онлайн резервация'
                }
              </Typography>
            </Paper>

            <Paper elevation={6}>
              <Stepper activeStep={activeStep} sx={{ pt: 1, pb: 1 }}>
                {steps.map((label, index) => (
                    <Step key={label}>
                      {index < activeStep && activeStep < steps.length ? (
                          <StepButton onClick={() => navigateToStep(index)}>{label}</StepButton>
                      ) : (
                          <StepLabel>{label}</StepLabel>
                      )}
                    </Step>
                ))}
              </Stepper>
            </Paper>


            <Paper elevation={6} sx={{ my: { xs: 1, md: 1 }}}>
              {
                affiliateText ?
                    <Alert
                        severity="info"
                        sx={{
                          '& .MuiAlert-message': {
                            flexGrow: 1,
                            whiteSpace: 'pre-line',
                          }
                        }}
                    >
                      {affiliateTextBlocks.map((block, index) => (
                          <Box
                              key={index}
                              sx={block.isBullet ? {
                                columnCount: { xs: 1, sm: block.rows.length >= 4 ? 2 : 1 },
                                columnGap: 3,
                              } : undefined}
                          >{block.rows.join('\n')}</Box>
                      ))}
                    </Alert>
                    :
                    null
              }
              {
                externalPromoCode === EVROPA_PROMO ?
                    <Alert severity="info">Благодарим Ви, че избрахте нас!
                      Заповядайте в нашия обект на кръстовището бул. Европа, ул. Добринова скала, и се възползвайте от специални преференциални условия, създадени специално за Вас.
                      Очакваме Ви!</Alert>
                    :
                    null
              }
              {
                (promo && !isBlocked) ?
                    <Alert severity="success">
                      Запазвате час с <b>{promo.discountLabel}</b> отстъпка от цената на ГТП.
                    </Alert>
                    :
                    null
              }
              {
                promoCodeUsed ?
                    <Alert severity="warning">
                      Ваучерът вече е използван и не може да бъде приложен отново. Възползвайте се от онлайн резервацията и спестете 5€ от цената на ГТП за ХИТ Младост.
                    </Alert>
                    :
                    null
              }
              {
                promoCodeInvalid ?
                    <Alert severity="warning">
                      Промо код <b>{externalPromoCode}</b> не е валиден.
                    </Alert>
                    :
                    null
              }
              {
                promoCodeReserved ?
                    <Alert severity="warning">
                      Вече има запазен час с този ваучер. Ваучерът може да бъде използван отново само ако откажете съществуващата резервация или смените часа си.
                    </Alert>
                    :
                    null
              }
            </Paper>

            {
                (activeStep === steps.length-1 && service === 1 && serviceType === 4) ?
                    <Paper>
                      <Alert severity="error">
                        В случай че желаете реглаж на бус, то височината му не трябва да надвишава 2,30м., а междуосието 3,60м.
                      </Alert>
                      </Paper>
                    : null

            }

            {
                (activeStep === steps.length-1 && service === 5 && serviceType === 4) ?
                    <Paper>
                      <Alert severity="error">
                        В случай че вашето МПС е БУС или друг едрогабаритен автомобил, поради пространствени ограничения, на посочените МПС-та не може да се извърши реглаж в обекта на бул. Европа, можете да запазите час за другите ни обекти. В случай, че имате съмнения дали вашето МПС попада в посочената категория можете да се обадите на 0882 606 606.                      </Alert>
                      </Paper>
                    : null

            }

            {
                (activeStep === steps.length-1 && service === 5 && serviceType === 7) ?
                    <Paper>
                      <Alert
                        severity="warning"
                        icon={<img src="/icons/forbidden-for-motorcycles-sign-logo.png" alt="" width="42" height="42" style={{flexShrink: 0}}/>}
                      >
                        <strong>ВАЖНА ИНФОРМАЦИЯ!</strong><br/>
                        Относно периодичните технически прегледи на мототехника: мотоциклети, ATV и други подобни МПС.<br/>
                        Ако желаете да извършите преглед на такъв тип МПС, моля, запазете час за нашия близък сервиз, разположен на паркинга на ХИТ и Практикер.<br/>
                        В пункта на бул. Европа 144В не се извършват прегледи на посочените по-горе МПС.<br/>
                        Благодарим за разбирането!
                      </Alert>
                    </Paper>
                    : null
            }


              <Paper elevation={6} style={{marginTop: 24}} sx={{ mt: {md: 1}, my: { xs: 3, md: 4 }, py: { xs: 2, md: 2 }, pr: { xs: 2, md: 2 }, pl: { xs: 0.5, sm: 2, md: 2 }, overflow: 'hidden' }}>
              <React.Fragment>
                {activeStep === steps.length ? (
                    <div key="success" className="step-forward-enter">
                      <Typography variant="h5" gutterBottom>
                        {isBlocked ? 'Системна грешка! Операцията НЕ може да бъде приключена!' : 'Успешна резервация! Благодарим Ви!'}
                      </Typography>
                      {isBlocked ? null :
                          <Paper variant="outlined" sx={{ my: { xs: 1, md: 2 }, p: { xs: 1, md: 2 } }}>
                        { (serviceType === 1 && isHotelVisible) &&
                          <Typography>
                            Ще вземем вашия хотел за гуми!
                          </Typography>
                        }
                        { (serviceType === 7) &&
                          <Typography>Важно! При закъснение от над 5 минути, ще трябва да Ви презапишем за следващия свободен час, поради техническа невъзможност да приемем следващия клиент. Моля проверете предварително за платен пътен данък.</Typography>
                        }
                        <Typography>
                          <b>Услуга:</b> {getServiceType(serviceType, service)}
                        </Typography>
                        <Typography>
                          <b>Локация:</b> {service === 1 ? "6+ Люлин" : (service === 2 ? "6+ Младост" : (service === 6 ? 'Младост - паркинг НIT Max' : "6+ бул. Европа"))}
                        </Typography>
                        <Typography>
                          <b>Дата:</b> { date != null && date.toDate() != null ?
                            date.toDate().toLocaleDateString("bg-BG", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
                            : null}
                        </Typography>
                        <Typography>
                          <b>Час:</b> {hourSelected ? hourSelected.replace(/^(\d):/, '0$1:') : hourSelected}
                        </Typography>
                      </Paper>
                      }
                      <br/>
                      <Grid container>
                        <Grid item xs={12} sm={6}>
                          <LoadingButton loading={!notificationLink} startIcon={<CalendarMonthIcon />}
                                         variant={'contained'} target="_blank" href={notificationLink}>
                            Добави в календар
                          </LoadingButton>

                        </Grid>

                        {/*<Grid item xs={12} sm={6}>
                          <Button color="secondary" startIcon={<HomeOutlinedIcon />} variant={'contained'}
                                  onClick={() => {
                                    clearAll();
                                    setActiveStep(0)
                                  }}>
                            Към начална страница
                          </Button>
                        </Grid>*/}
                      </Grid>
                    </div>
                ) : (
                    <div
                        key={activeStep}
                        className={stepDirectionRef.current === 'forward' ? 'step-forward-enter' : 'step-back-enter'}
                    >
                      {getStepContent(activeStep)}
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {activeStep > 0 && (
                            <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                              Назад
                            </Button>
                        )}

                        {activeStep === 2 && (
                          <Button
                              variant="contained"
                              onClick={handleNext}
                              disabled={
                                (serviceType === 1 && !(externalProductName && externalProductQuantity) ? (!hotelPersonalChoice) : false)
                                || hotelOtherServiceOpen
                                || (phone === '' || phone === null)
                                || (plate === '' || plate === null)
                                || (name === ''  || name === null)
                                || (brand === '' || brand === null)
                              }
                              sx={{ mt: 3, ml: 1 }}
                          >
                            Готово
                          </Button>
                        )}
                      </Box>
                    </div>
                )}
              </React.Fragment>
            </Paper>
            <Copyright />
          </Container>


          <MessageDialog
              openAndText={message}
              handleClose={() => {
                navigateToStep(0)
                setMessage(null)
              }}
              dangerMode
              positiveText={'Смени го'}
              positiveAction={() => {
                navigateToStep(0)
                setMessage(null)
              }}/>
        </ThemeProvider>
      </React.StrictMode>

  );
}

export default MainForm;
